// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-dark: #2563eb;
  --secondary-color: #10b981;
  --secondary-dark: #059669;
  --text-color: #374151;
  --text-light: #6b7280;
  --border-color: #e5e7eb;
  --bg-light: #f9fafb;
  --bg-medium: #f3f4f6;
  --bg-dark: #e5e7eb;
}

.hier-modal-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.hier-modal {
  background: #ffffff;
  border-radius: 0.75rem;
  width: 100%;
  max-width: 600px;
  max-height: 85vh;
  overflow: hidden;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.hier-modal h2 {
  font-weight: 800;
  font-size: 1.4rem;
  text-align: center;
  margin-bottom: 1rem;
  color: var(--primary-color);
  -webkit-user-select: none;
          user-select: none;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--border-color);
}
.hier-modal .hier-modal-content {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 0.75rem;
  padding-bottom: 1rem;
  color: var(--text-color);
  font-size: 0.95rem;
}
.hier-modal .hier-modal-content::-webkit-scrollbar-track {
  background: var(--bg-medium);
  border-radius: 10px;
}
.hier-modal .hier-modal-content::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 10px;
  height: 8px;
}
.hier-modal .hier-modal-content::-webkit-scrollbar-thumb:hover {
  background: var(--primary-dark);
}
.hier-modal .hier-modal-content .tree-node {
  position: relative;
  padding-left: 1.5rem;
  margin-bottom: 0.25rem;
}
.hier-modal .hier-modal-content .tree-node:last-child {
  margin-bottom: 0;
}
.hier-modal .hier-modal-content .tree-node .node-content {
  display: flex;
  align-items: center;
  background-color: var(--bg-light);
  padding: 0.5rem 0.75rem;
  border-radius: 0.375rem;
  border: 1px solid var(--border-color);
  transition: background-color 0.2s ease, border-color 0.2s ease;
  min-height: 40px;
}
.hier-modal .hier-modal-content .tree-node .node-content:hover {
  background-color: var(--bg-medium);
  border-color: var(--primary-color);
}
.hier-modal .hier-modal-content .tree-node .expand-icon {
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 0.5rem;
  color: var(--text-light);
  transition: transform 0.2s ease;
  flex-shrink: 0;
}
.hier-modal .hier-modal-content .tree-node .expand-icon svg {
  width: 100%;
  height: 100%;
}
.hier-modal .hier-modal-content .tree-node .expand-icon.expanded {
  transform: rotate(90deg);
}
.hier-modal .hier-modal-content .tree-node .node-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  flex-grow: 1;
}
.hier-modal .hier-modal-content .tree-node .node-label input[type=checkbox] {
  cursor: pointer;
  accent-color: var(--primary-color);
  border-radius: 4px;
  flex-shrink: 0;
}
.hier-modal .hier-modal-content .tree-node .node-label .node-name {
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  color: #374151;
  text-overflow: ellipsis;
  flex-grow: 1;
}
.hier-modal .hier-modal-content .tree-node .node-label .node-role {
  background: var(--secondary-color);
  color: #374151;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.6rem;
  border-radius: 9999px;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
}
.hier-modal .hier-modal-content .tree-node .node-children {
  margin-left: 1.5rem;
  padding-left: 1rem;
  border-left: 1px dashed var(--border-color);
  margin-top: 0.25rem;
}
.hier-modal .hier-modal-content .tree-node::before {
  content: "";
  position: absolute;
  left: 0.75rem;
  top: 1.25rem;
  width: 0.75rem;
  height: 1px;
  background-color: var(--border-color);
}
.hier-modal .hier-modal-content .tree-node .node-children > .tree-node::before {
  background-color: var(--border-color);
}
.hier-modal .hier-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-color);
}
.hier-modal .hier-modal-actions button {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 700;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.25s ease, transform 0.1s ease;
}
.hier-modal .hier-modal-actions button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.hier-modal .hier-modal-actions .hier-modal-submit-btn {
  background-color: var(--primary-color);
  color: white;
}
.hier-modal .hier-modal-actions .hier-modal-close-btn {
  background-color: #6c757d;
  color: white;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .hier-modal-overlay .hier-modal {
    padding: 1.25rem;
  }
  .hier-modal-overlay .hier-modal h2 {
    font-size: 1.5rem;
  }
}
@media (max-width: 480px) {
  .hier-modal-overlay .hier-modal {
    padding: 1rem;
    margin: 0.75rem;
  }
  .hier-modal-overlay .hier-modal h2 {
    font-size: 1.3rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-actions {
    flex-direction: column;
    gap: 0.75rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-actions button {
    width: 100%;
    min-width: unset;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node {
    padding-left: 1rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node .expand-icon {
    margin-right: 0.25rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node .node-label {
    gap: 0.5rem;
  }
  .hier-modal-overlay .hier-modal .hier-modal-content .tree-node .node-children {
    margin-left: 1rem;
    padding-left: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/HierarchyModal/HierarchyModal.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,0BAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,QAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EACA,4CAAA;AACJ;AAEE;EACE,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,wBAAA;EACA,kBAAA;AAAJ;AAQI;EACE,4BAAA;EACA,mBAAA;AANN;AASI;EACE,gCAAA;EACA,mBAAA;EACA,WAAA;AAPN;AASM;EACE,+BAAA;AAPR;AAWI;EACE,kBAAA;EACA,oBAAA;EACA,sBAAA;AATN;AAWM;EACE,gBAAA;AATR;AAYM;EACE,aAAA;EACA,mBAAA;EACA,iCAAA;EACA,uBAAA;EACA,uBAAA;EACA,qCAAA;EACA,8DAAA;EACA,gBAAA;AAVR;AAYQ;EACE,kCAAA;EACA,kCAAA;AAVV;AAcM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,wBAAA;EACA,+BAAA;EACA,cAAA;AAZR;AAcQ;EACE,WAAA;EACA,YAAA;AAZV;AAeQ;EACE,wBAAA;AAbV;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAfR;AAiBQ;EAGE,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,cAAA;AAjBV;AAoBQ;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;AAlBV;AAqBQ;EACE,kCAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,cAAA;AAnBV;AAuBM;EACE,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;AArBR;AAyBM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,qCAAA;AAvBR;AA6BM;EACE,qCAAA;AA3BR;AAgCE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,yCAAA;AA9BJ;AAgCI;EACE,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,4DAAA;AA9BN;AAgCM;EACE,wBAAA;EACA,wCAAA;AA9BR;AAkCI;EACE,sCAAA;EACA,YAAA;AAhCN;AAmCI;EACE,yBAAA;EACA,YAAA;AAjCN;;AA0CA,2BAAA;AACA;EACE;IACE,gBAAA;EAvCF;EAyCE;IACE,iBAAA;EAvCJ;AACF;AA2CA;EACE;IACE,aAAA;IACA,eAAA;EAzCF;EA2CE;IACE,iBAAA;EAzCJ;EA4CE;IACE,sBAAA;IACA,YAAA;EA1CJ;EA4CI;IACE,WAAA;IACA,gBAAA;EA1CN;EA+CI;IACE,kBAAA;EA7CN;EA+CM;IACE,qBAAA;EA7CR;EAgDM;IACE,WAAA;EA9CR;EAiDM;IACE,iBAAA;IACA,qBAAA;EA/CR;AACF","sourcesContent":[":root {\r\n  --primary-dark: #2563eb;\r\n  --secondary-color: #10b981; // A vibrant green\r\n  --secondary-dark: #059669;\r\n  --text-color: #374151;\r\n  --text-light: #6b7280;\r\n  --border-color: #e5e7eb;\r\n  --bg-light: #f9fafb;\r\n  --bg-medium: #f3f4f6;\r\n  --bg-dark: #e5e7eb;\r\n}\r\n\r\n.hier-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background-color: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  padding: 1rem; // Add padding for smaller screens\r\n}\r\n\r\n.hier-modal {\r\n  background: #ffffff;\r\n  border-radius: 0.75rem;\r\n  width: 100%;\r\n  max-width: 600px; // Slightly reduced max-width for better focus\r\n  max-height: 85vh; // Increased max-height\r\n  overflow: hidden;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.25);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1rem; // Spacing between elements\r\n\r\n  h2 {\r\n    font-weight: 800;\r\n    font-size: 1.4rem;\r\n    text-align: center;\r\n    margin-bottom: 1rem;\r\n    color: var(--primary-color);\r\n    user-select: none;\r\n    padding-bottom: 0.5rem;\r\n    border-bottom: 2px solid var(--border-color);\r\n  }\r\n\r\n  .hier-modal-content {\r\n    flex-grow: 1;\r\n    overflow-y: auto;\r\n    padding-right: 0.75rem; // More padding for scrollbar\r\n    padding-bottom: 1rem; // Padding at the bottom\r\n    color: var(--text-color);\r\n    font-size: 0.95rem;\r\n\r\n    // Custom Scrollbar for better aesthetics\r\n    &::-webkit-scrollbar {\r\n      // width: 8px;\r\n\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n      background: var(--bg-medium);\r\n      border-radius: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n      background: var(--primary-color);\r\n      border-radius: 10px;\r\n      height: 8px;\r\n\r\n      &:hover {\r\n        background: var(--primary-dark);\r\n      }\r\n    }\r\n\r\n    .tree-node {\r\n      position: relative;\r\n      padding-left: 1.5rem; // Base indentation for all nodes\r\n      margin-bottom: 0.25rem; // Smaller margin for denser tree\r\n\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      .node-content {\r\n        display: flex;\r\n        align-items: center;\r\n        background-color: var(--bg-light);\r\n        padding: 0.5rem 0.75rem;\r\n        border-radius: 0.375rem; // Slightly smaller border-radius\r\n        border: 1px solid var(--border-color);\r\n        transition: background-color 0.2s ease, border-color 0.2s ease;\r\n        min-height: 40px; // Ensure consistent height\r\n\r\n        &:hover {\r\n          background-color: var(--bg-medium);\r\n          border-color: var(--primary-color);\r\n        }\r\n      }\r\n\r\n      .expand-icon {\r\n        width: 1rem;\r\n        height: 1rem;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        cursor: pointer;\r\n        margin-right: 0.5rem;\r\n        color: var(--text-light);\r\n        transition: transform 0.2s ease;\r\n        flex-shrink: 0;\r\n\r\n        svg {\r\n          width: 100%;\r\n          height: 100%;\r\n        }\r\n\r\n        &.expanded {\r\n          transform: rotate(90deg);\r\n        }\r\n      }\r\n\r\n      .node-label {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 0.75rem; // Slightly reduced gap\r\n        cursor: pointer;\r\n        flex-grow: 1; // Allow label to take available space\r\n\r\n        input[type=\"checkbox\"] {\r\n          // width: 20px;\r\n          // height:20px ;\r\n          cursor: pointer;\r\n          accent-color: var(--primary-color);\r\n          border-radius: 4px;\r\n          flex-shrink: 0;\r\n        }\r\n\r\n        .node-name {\r\n          font-weight: 600;\r\n          white-space: nowrap;\r\n          overflow: hidden;\r\n          color: #374151;\r\n          text-overflow: ellipsis; // Truncate long names\r\n          flex-grow: 1; // Allows name to take space\r\n        }\r\n\r\n        .node-role {\r\n          background: var(--secondary-color); // Use secondary color\r\n          color: #374151;\r\n          font-size: 0.7rem; // Smaller role font\r\n          font-weight: 600;\r\n          padding: 0.2rem 0.6rem;\r\n          border-radius: 9999px;\r\n          user-select: none;\r\n          flex-shrink: 0; // Prevent role from shrinking\r\n        }\r\n      }\r\n\r\n      .node-children {\r\n        margin-left: 1.5rem; // Indentation for children\r\n        padding-left: 1rem; // Space for the vertical line\r\n        border-left: 1px dashed var(--border-color); // Vertical hierarchy line\r\n        margin-top: 0.25rem; // Space between parent and children block\r\n      }\r\n\r\n      // Drawing horizontal lines\r\n      &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0.75rem; // Matches half of padding-left of .tree-node\r\n        top: 1.25rem; // Vertical center of the node-content\r\n        width: 0.75rem; // Length of the horizontal line\r\n        height: 1px;\r\n        background-color: var(--border-color);\r\n        // Only show horizontal line if it's not the root or the first child of its parent\r\n        // This is tricky with pure CSS. Often easier to manage with a class or JS.\r\n        // For simplicity, we'll draw it for all for now or rely on indentation.\r\n      }\r\n\r\n      .node-children>.tree-node::before {\r\n        background-color: var(--border-color);\r\n      }\r\n    }\r\n  }\r\n\r\n  .hier-modal-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    gap: 1rem;\r\n    padding-top: 1rem;\r\n    border-top: 1px solid var(--border-color);\r\n\r\n    button {\r\n      padding: 0.5rem 1rem;\r\n      font-size: 0.9rem;\r\n      font-weight: 700;\r\n      border: none;\r\n      border-radius: 0.5rem;\r\n      cursor: pointer;\r\n      transition: background-color 0.25s ease, transform 0.1s ease;\r\n\r\n      &:active {\r\n        transform: translateY(0);\r\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n      }\r\n    }\r\n\r\n    .hier-modal-submit-btn {\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n    }\r\n\r\n    .hier-modal-close-btn {\r\n      background-color: #6c757d; // A neutral grey for close\r\n      color: white;\r\n\r\n      // &:hover {\r\n      //   background-color: #5a6268;\r\n      // }\r\n    }\r\n  }\r\n}\r\n\r\n/* Responsive Adjustments */\r\n@media (max-width: 768px) {\r\n  .hier-modal-overlay .hier-modal {\r\n    padding: 1.25rem;\r\n\r\n    h2 {\r\n      font-size: 1.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .hier-modal-overlay .hier-modal {\r\n    padding: 1rem;\r\n    margin: 0.75rem; // Adjusted margin for smaller screens\r\n\r\n    h2 {\r\n      font-size: 1.3rem;\r\n    }\r\n\r\n    .hier-modal-actions {\r\n      flex-direction: column;\r\n      gap: 0.75rem;\r\n\r\n      button {\r\n        width: 100%;\r\n        min-width: unset; // Remove min-width on small screens\r\n      }\r\n    }\r\n\r\n    .hier-modal-content {\r\n      .tree-node {\r\n        padding-left: 1rem; // Reduce base indentation\r\n\r\n        .expand-icon {\r\n          margin-right: 0.25rem;\r\n        }\r\n\r\n        .node-label {\r\n          gap: 0.5rem;\r\n        }\r\n\r\n        .node-children {\r\n          margin-left: 1rem; // Reduce child indentation\r\n          padding-left: 0.75rem;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
